export const ACTIONS_TRANSLATE = {
    actions: {
        create: "Crear",
        add: "Agregar",
        import: "Importar",
        save: "Guardar",
        back: "Volver",
        print: "Imprimir",
        continue: "Continuar",
        copy: "Copiar",
        ok: "Ok"
    }
};
